import { createFileRoute } from '@tanstack/react-router';

import { SyncOptionSetsPage } from '@pages/sync';

/**
 * Sync - Option Sets
 *
 * Route: /:locale/sync/option-sets
 */
export const Route = createFileRoute('/$locale/_authenticated/sync/option-sets')({
  component: SyncOptionSetsRoute,
});

function SyncOptionSetsRoute() {
  return <SyncOptionSetsPage />;
}
